import GQLTable from '../../utils/gql-mui-rhf/Table';

// material
import { Box, Grid, Container, Typography } from '@mui/material';
// components
import Page from '../../components/Page';
// ----------------------------------------------------------------------

export default function People() {
    return (
        <Page title="Firm Unit | FINBACK670">
            <Container maxWidth="xl">
                <Box sx={{ pb: 5 }}>
                    <Typography variant="h4">Firm Unit</Typography>
                </Box>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <GQLTable
                            queryString={'projectFirmUnits'}
                            addMutationString={'createProjectFirmUnit'}
                            deleteMutationString={'deleteProjectFirmUnit'}
                            updateMutationString={'updateProjectFirmUnit'}
                            updateModal={true}
                        />
                    </Grid>
                </Grid>
            </Container>
        </Page>
    );
}
